import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_2 = { class: "svg-icon svg-icon-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("原值")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("分层")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("百分比")

import { MenuComponent } from "@/assets/ts/components";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ref, onMounted, reactive } from "vue";
import Datatable from "@/components/kt-datatable/Datatable2.vue";
import ApiService from "@/core/services/ApiService";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {ElMessage} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const dataT = ref<HTMLElement | null>(null);
const apiUrl = 'programme/sorting';
const tableHeader = ref([
  { name: "ID", key: "id" },
  { name: "排序名称", key: "name" },
  { name: "维护人", key: "user" },
  { name: "创建人", key: "creator" },
  { name: "创建时间", key: "create_time", sortable: true, sortingField: "-create_time" },
  { name: "更新时间", key: "update_time", sortable: true },
]);
const filters = reactive({
  search: '',
  user_id: route.name == 'selection.my' ? store.getters.currentUser.id : 0,
});
const formData = reactive({
  id: 0,
  name: '',
  formula: '',
  key_name:'',
  cat_id: '',
  dimension_id: '',
  dimension_name: '',
  dimension_field: '',
  dtype: 0,
  sorting_type: 1,
  settings: [] as any[],
});
const rules = {
  name: [
    { required: true, message: '请输入排序方案名称！', trigger: 'blur' },
  ],
  formula: [
    { required: true, message: '请输入排序策略公式！', trigger: 'blur' },
  ],
  key_name: [
    { required: true, message: '请输入指标名称！', trigger: 'blur' },
  ],
  dimension_id: [
    { required: true, message: '请选择对应维度！', trigger: 'blur' },
  ],
};

const config = reactive({
  users: [] as any[],  //维护人列表
  dimension_category: [] as any[],  //站点维度类别配置
  dimension: {} as any,  //站点维度配置
  attrs: {} as any,  //站点维度属性配置
});
const loading = ref(false);  //载入状态
const keys = ref<Array<any>>([]);  //指标列表
const dimension = ref<any>(null); //选中的维度

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("selection.sorting", ["selection.name"]);

  loading.value = true;
  if ((dataT as any) != undefined) (dataT as any).value.btnLoading = true;
  ApiService.get('programme/config').then(({data}) => {
    if (data.area.length < 1) {
      ElMessage.error('模块未开通或基础数据不足，请与管理员联系！');
    } else {
      config.users = [...data.users];
      loading.value = false;
      if ((dataT as any) != undefined) (dataT as any).value.btnLoading = false;
    }
  })
  loadDimension();
});

const loadDimension = function() {
  if (config.dimension.length < 1 || Object.keys(config.attrs).length < 1){
    ApiService.get('programme/dimension').then(({data}) => {
      if (data.dimension.length < 1 || Object.keys(data.attrs).length < 1) {
        ElMessage.error('基础数据不足，请与管理员联系！');
      } else {
        let dc: Array<any> = [];
        let dimension = {};
        for (let d of data.dimension) {
          dc.push({
            id: d.cat_id,
            name: d.cat_name,
          })
          dimension[d.cat_id] = d.children
        }
        config.dimension_category = [...dc];
        config.dimension = dimension;
        config.attrs = data.attrs;
      }
    });
  }
}

const add = function() {
  keys.value = [];
}
const edit = function(item) {
  keys.value = item.keys;
}

const dimensionChange = function(val) {
  dimension.value = val;
  formData.dimension_name = val.dimension_name;
  formData.dimension_field = val.dimension_field;
  formData.dtype = val.dtype;
  formData.settings = [];
  if (dimension.value.dtype === 2) {
    formData.sorting_type = 1;
  }
}

// 增加输入项
const addItem = function (){
  formData.settings.push({
    'dselect': '',
    'dvalue': dimension.value.dtype === 1 ? 0.001 : '',
    'score': 1,
  })
}
// 减少输入项
const deleteItem = function (i){
  formData.settings.splice(i, 1)
}
// 提交后跳转到指标页
const submitAfter = function (item) {
  if (formData.id === 0)
    router.push({name: 'selection.sortingKey', params: {sid: item.id}});
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createBlock(Datatable, {
    ref_key: "dataT",
    ref: dataT,
    apiUrl: apiUrl,
    "table-header": tableHeader.value,
    "enable-items-per-page-dropdown": true,
    data: _unref(formData),
    rules: rules,
    filters: _unref(filters),
    title: "自定义排序",
    addAction: add,
    editAction: edit,
    submitAfterAction: submitAfter,
    delete: false
  }, {
    "search-back": _withCtx(() => [
      _hoisted_1,
      (_unref(route).name !== 'selection.my')
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            modelValue: _unref(filters).user_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).user_id) = $event)),
            size: "small",
            placeholder: "请选择维护人",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (dataT.value.setCurrent(1))),
            style: {"width":"120px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_el_option, {
                value: 0,
                key: 0,
                label: "所有维护人"
              })),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).users, (v) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  value: v.id,
                  key: v.id,
                  label: v.username
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    "cell-name": _withCtx(({ row: r }) => [
      _createVNode(_component_router_link, {
        to: {name: 'selection.sortingKey', params: {sid: r.id}},
        class: "text-gray-600"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(r.name), 1)
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    "cell-user": _withCtx(({ row: r }) => [
      _createTextVNode(_toDisplayString(r.user.username), 1)
    ]),
    "cell-creator": _withCtx(({ row: r }) => [
      _createTextVNode(_toDisplayString(r.creator.username), 1)
    ]),
    "actions-front": _withCtx(({ row: r }) => [
      _createVNode(_component_router_link, {
        to: {name: 'selection.sortingKey', params: {sid: r.id}},
        title: "下钻",
        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr082.svg" })
          ])
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    form: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "排序名称",
        prop: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _unref(formData).name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).name) = $event)),
            placeholder: "名称",
            size: "small",
            style: {"width":"400px"}
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (_unref(formData).id === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              label: "首个指标名称",
              prop: "key_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).key_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).key_name) = $event)),
                  placeholder: "指标名称",
                  size: "small",
                  style: {"width":"200px"},
                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (_unref(formData).formula = keys.value.length === 0 ? _unref(formData).key_name : _unref(formData).formula))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "对应维度",
              prop: "dimension_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).cat_id,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).cat_id) = $event)),
                  size: "small",
                  placeholder: "请选择类型",
                  style: {"width":"120px"},
                  onChange: _cache[6] || (_cache[6] = ($event: any) => {_unref(formData).dimension_id = '';})
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).dimension_category, (v) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        value: v.id,
                        key: v.id,
                        label: v.name
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_4,
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).dimension_id,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).dimension_id) = $event)),
                  size: "small",
                  placeholder: "请选择维度",
                  style: {"width":"120px"},
                  disabled: _unref(formData).cat_id === ''
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).dimension[_unref(formData).cat_id], (v) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        value: v.dimension_id,
                        key: v.dimension_id,
                        label: v.dimension_name,
                        onClick: ($event: any) => (dimensionChange(v))
                      }, null, 8, ["value", "label", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "类型",
              prop: "sorting_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(formData).sorting_type,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).sorting_type) = $event)),
                  size: "small",
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_unref(formData).settings = []))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, {
                      label: 2,
                      disabled: dimension.value && dimension.value.dtype === 2
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_radio_button, {
                      label: 3,
                      disabled: dimension.value && dimension.value.dtype === 2
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (dimension.value && (dimension.value.dtype === 1 && _unref(formData).sorting_type !== 1 || dimension.value.dtype === 2 && _unref(formData).sorting_type === 1))
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "具体设置"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      data: _unref(formData).settings,
                      "max-height": "400",
                      stripe: "",
                      "show-header": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "规则",
                          align: "center",
                          width: "110"
                        }, {
                          default: _withCtx((scope) => [
                            (dimension.value.dtype === 2)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  modelValue: scope.row.dselect,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.dselect) = $event),
                                  placeholder: "请选择",
                                  size: "small",
                                  style: {"width":"100px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      value: "in",
                                      label: "包含"
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: "not in",
                                      label: "不包含"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (dimension.value.dtype === 1)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 1,
                                  modelValue: scope.row.dselect,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.dselect) = $event),
                                  placeholder: "请选择",
                                  size: "small",
                                  style: {"width":"100px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      value: "gt",
                                      label: "大于"
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: "lt",
                                      label: "小于"
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: "eq",
                                      label: "等于"
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: "gte",
                                      label: "大于等于"
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: "lte",
                                      label: "小于等于"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "属性值",
                          align: "center"
                        }, {
                          default: _withCtx((scope) => [
                            (dimension.value.dtype === 2)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  modelValue: scope.row.dvalue,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.dvalue) = $event),
                                  placeholder: "请选择",
                                  size: "small",
                                  multiple: "",
                                  filterable: "",
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).attrs[_unref(formData).dimension_id], (it) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: it['attr_name'],
                                        value: it['attr_name'],
                                        label: it['attr_name']
                                      }, null, 8, ["value", "label"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (dimension.value.dtype === 1)
                              ? (_openBlock(), _createBlock(_component_el_input_number, {
                                  key: 1,
                                  modelValue: scope.row.dvalue,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.dvalue) = $event),
                                  size: "small",
                                  min: 0.001,
                                  controls: false,
                                  precision: 3,
                                  style: {"width":"200px"}
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "min"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "得分",
                          align: "center",
                          width: "90"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_input_number, {
                              modelValue: scope.row.score,
                              "onUpdate:modelValue": ($event: any) => ((scope.row.score) = $event),
                              size: "small",
                              min: 0,
                              precision: 1,
                              step: 0.1,
                              max: 5,
                              controls: false,
                              style: {"width":"80px"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "" }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-remove",
                              title: "删除",
                              onClick: ($event: any) => (deleteItem(scope.$index))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    _createVNode(_component_el_button, {
                      type: "success",
                      plain: "",
                      size: "mini",
                      icon: "el-icon-circle-plus",
                      title: "增加",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (addItem())),
                      style: {"margin-top":"4px"}
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (keys.value.length > 0)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "指标"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keys.value, (k) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: k.id,
                  class: "mx-1",
                  effect: "light"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(k.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, {
        prop: "formula",
        label: "排序策略"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _unref(formData).formula,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formData).formula) = $event)),
            type: "textarea",
            rows: "3",
            size: "small",
            placeholder: "请输入排序策略公式",
            readonly: keys.value.length === 0,
            style: {"width":"90%"}
          }, null, 8, ["modelValue", "readonly"]),
          (_unref(formData).id === 0)
            ? (_openBlock(), _createBlock(_component_el_alert, {
                key: 0,
                title: "首次创建自定义排序，排序策略只有一个指标，可以添加更多指标后再来丰富排序策略公式",
                type: "warning",
                closable: false,
                style: {"padding":"0","line-height":"24px","background":"none"}
              }))
            : _createCommentVNode("", true),
          (_unref(formData).id > 0)
            ? (_openBlock(), _createBlock(_component_el_alert, {
                key: 1,
                title: "排序策略请输入含有指标名称及加减乘除的公式，加减乘除、括号等符号前后必须有空格，必须使用半码运算符，即：( 指标A + 指标B ) * 1.2 / 100",
                type: "warning",
                closable: false,
                style: {"padding":"0","line-height":"24px","background":"none"}
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["table-header", "data", "filters"]))
}
}

})